document.addEventListener("DOMContentLoaded", () => {
    const overlays = document.querySelectorAll<HTMLElement>(".agenda-lightbox-overlay");

    function openLightbox(overlay: HTMLElement) {
        overlay.removeAttribute("hidden");
        // Double rAF: let the browser paint the initial hidden state before transitioning.
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                overlay.classList.add("is-open");
                const content = overlay.querySelector<HTMLElement>(".agenda-lightbox-content");
                if (content) content.focus();
            });
        });
    }

    function closeLightbox(overlay: HTMLElement) {
        overlay.classList.remove("is-open");
        // Restore hidden after the CSS transition finishes.
        const onEnd = (e: TransitionEvent) => {
            if (e.target !== overlay) return;
            overlay.removeEventListener("transitionend", onEnd);
            if (!overlay.classList.contains("is-open")) {
                overlay.setAttribute("hidden", "");
            }
        };
        overlay.addEventListener("transitionend", onEnd);
        const id = overlay.id;
        if (id) {
            const trigger = document.querySelector<HTMLElement>(
                `[aria-controls="${CSS.escape(id)}"]`
            );
            if (trigger) trigger.focus();

        }
    };

    overlays.forEach((overlay) => {
        const trigger = document.querySelector<HTMLElement>(
            `[aria-controls="${CSS.escape(overlay.id)}"]`
        );

        if (trigger) {
            trigger.addEventListener("click", () => openLightbox(overlay));
            trigger.addEventListener("keydown", (e: KeyboardEvent) => {
                if (e.repeat) return;
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    openLightbox(overlay);
                }
            });
        }

        const closeBtn = overlay.querySelector<HTMLElement>(".agenda-lightbox-close");
        if (closeBtn) {
            closeBtn.addEventListener("click", () => closeLightbox(overlay));
        }

        // Click on backdrop (outside content box) closes the lightbox
        overlay.addEventListener("click", (e: MouseEvent) => {
            const content = overlay.querySelector<HTMLElement>(".agenda-lightbox-content");
            if (content && !content.contains(e.target as Node)) {
                closeLightbox(overlay);
            }
        });
    });

    // ESC key closes whichever lightbox is currently open
    document.addEventListener("keydown", (e: KeyboardEvent) => {
        if (e.repeat) return;
        if (e.key === "Escape") {
            const open = document.querySelector<HTMLElement>(".agenda-lightbox-overlay.is-open");
            if (open) {
                closeLightbox(open);
            }
        }
    });
});

export { };
